import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import { css } from '@emotion/core';

const override = css`
    display: flex;
    justify-content: center;
    margin: 15px auto;
    padding: 2px;
`;
export default function Loading(){
  return (<BeatLoader color={'#185335'} css={override} sizeUnit={"px"} size={20} loading={true} />)
}